import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconAnchor24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconAnchor24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12 7.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m2.5-1a2.5 2.5 0 0 1-1.75 2.386V11.5h2a.75.75 0 1 1 0 1.5h-2v4.954c2.132-.266 3.867-1.65 4.548-3.467a.75.75 0 1 1 1.405.526c-.906 2.417-3.207 4.176-5.953 4.45v.787a.75.75 0 0 1-1.5 0v-.787c-2.745-.274-5.046-2.033-5.952-4.45a.75.75 0 0 1 1.404-.526c.682 1.817 2.416 3.2 4.548 3.467V13h-2a.75.75 0 0 1 0-1.5h2V8.886A2.501 2.501 0 1 1 14.5 6.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconAnchor24);
